import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.button.Component,
    ds.input.textArea.Component,
    ds.input.file.Component,
  ],
  selector: 'atn-mosaic-page-ai-generate-dialog',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@Link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  public generateClickHandler(): void {
    this.pagesEc.assistant.actions.saveEditPrompt
      .from('Mosaic.Page.Ai.Generate.Dialog.Buttons.Generate.Clicked')
      .dispatch()
  }
}
